<h1>
  @if (tittel() == null) {
    {{ 'Oppsummering av resultater'|translate }}
  } @else {
    {{ tittel() }}
  }
</h1>

<!-- merk at spørsmål som ligger før første gruppetittel ikke vil vøre inkludert i grupperinger() -->
@for (gruppering of grupperinger(); track gruppering.gruppe.spoersmaal.id; ) {
  @if (!gruppering.alleInnslagErAvSammeType()) {
    <!--
       dersom det ikke finnes noe aggregat for gruppen informerer vi om dette
       merk at vi ikke kan putte en @if rundt <ng-container resultat-fragment> og på den måte droppe dupliseringen av <spoerreundersoekelse-spoersmaal-resultat..
       ng-container må være statisk inkludert/ikke inkludert
    -->
    <div class="gruppe-uten-svarverdier">
      <div class="spørsmålstittel">
        <h2 class="grupperingstittel">{{ gruppering.gruppe.spoersmaal.tittel }}</h2>
        <ng-container *ngTemplateOutlet="visSkjulInnslagFragment; context: {gruppe: gruppering}"/>
      </div>
      <div class="svar" matTooltip="{{'Gruppen inneholder spørsmål av ulik type, oppsummering kan derfor ikke lages'|translate}}">
        <span>{{ 'Ingen oppsummering tilgjengelig'|translate }}, </span>
        @if (!gruppering.viserInnslag()) {
          <a (click)="gruppering.visInnslag()">{{ 'vis alle spørsmålene i gruppen'|translate }}</a>
        } @else {
          <a (click)="gruppering.skjulInnslag()">{{ 'skjul alle spørsmålene i gruppen'|translate }}</a>
        }
      </div>
    </div>
  } @else {
    <!-- vis aggregerte verdier for gruppen  -->
    <spoerreundersoekelse-spoersmaal-korellert-resultat [resultat]="gruppering.gruppe" [oppsett]="gruppering.resultatOppsett()" class="gruppe-tittel">
      <ng-container *ngTemplateOutlet="visSkjulInnslagFragment; context: {gruppe: gruppering}"/>
    </spoerreundersoekelse-spoersmaal-korellert-resultat>
  }

  <!-- liste spørsmålene i gruppen -->
  @if (gruppering.viserInnslag()) {
    @for (resultat of gruppering.innslag; track resultat.spoersmaal.id; ) {
      <spoerreundersoekelse-spoersmaal-korellert-resultat [resultat]="resultat" [oppsett]="resultat.resultatOppsett()" class="gruppe-innslag"/>
    }
  }
}

<ng-template #visSkjulInnslagFragment [typetNgTemplate]="visSkjulInnslagFragmentKontekstType" let-gruppe="gruppe">
  @if (!gruppe.viserInnslag()) {
    <button mat-button class="vis-innslag" (click)="gruppe.visInnslag()" data-testid="vis-innslag-knapp">
      {{ 'Vis {antall} spørsmål'|translate:{antall: gruppe.innslag.length} }}
    </button>
  } @else {
    <button mat-button class="vis-innslag" (click)="gruppe.skjulInnslag()">
      {{ 'Skjul {antall} spørsmål'|translate:{antall: gruppe.innslag.length} }}
    </button>
  }
</ng-template>
